<template>
  <div class="tags-field container" @keydown.stop>
    <div class="title">标签</div>
    <ul class="items">
      <li class="item" v-for="(item, i) in items">
        <div>{{item.text}}</div>
        <div class="remove-btn" @click="removeTag(i)"></div>
      </li>
    </ul>
    <input
      type="text"
      class="input"
      placeholder="填写标签便于检索，最多不超过5个，点击Enter隔开多个标签"
      v-model="inputValue"
      v-show="items.length < 5"
      @keyup.enter="inputBlur()"
      @blur="inputBlur()"
      @change="addTag()"
      @input="onInput()"
    />
    <div class="tip" v-show="validState === 'fail' && !forceHidden">{{validTip}}</div>
  </div>
</template>

<script>
const getMixLen = function(str) {
  if (str == null) return 0;
  if (typeof str !== "string") {
    str += "";
  }
  return str.replace(/[^\x00-\xff]/g, "01").length;
};

export default {
  model: {
    prop: "value",
    event: "submit"
  },
  props: {
    value: String
  },
  data() {
    return {
      inputValue: "",
      placeholder: "填写标签便于检索，最多不超过5个，点击Enter隔开多个标签",
      disabled: false,
      items: [],
      isShowInput: true,
      validTip: "请填写标签，每个标签最多8个汉字或16个字母",
      validState: "pass",
      isRequired: false,
      limitLength: 16,
      forceHidden: false
    };
  },
  methods: {
    validate() {
      let correctTextLen = getMixLen(this.inputValue) <= 16;
      return correctTextLen;
    },
    onInput() {
      let isPass = this.validate();
      if (isPass) {
        this.validState = "pass";
        this.forceHidden = true;
      } else {
        this.validState = "fail";
        this.forceHidden = false;
      }
    },
    inputBlur() {
      if (!this.inputValue) {
        this.forceHidden = true;
        return;
      }
      let isPass = this.validate();
      if (isPass) {
        this.addTag();
        this.forceHidden = true;
      } else {
        let str = this.inputValue;
        let re = /[^\x00-\xff]/;
        let chars = this.inputValue.split("");
        let charsLen = chars.length;
        while (getMixLen(str) > this.limitLength) {
          charsLen--;
          chars.length = charsLen;
          str = chars.join("");
        }
        this.inputValue = str;
        this.addTag();
        this.forceHidden = true;
      }
    },
    addTag() {
      let trimed = this.inputValue.trim();
      this.inputValue = trimed;
      let isPass = this.inputValue && this.validate();
      if (isPass) {
        this.items.push({ text: this.inputValue });
        this.inputValue = "";
        this.validState = "pass";
        this.forceHidden = true;
      } else {
        this.validState = "fail";
        this.forceHidden = false;
      }
      this.createParamTags();
    },
    removeTag(index) {
      this.items.splice(index, 1);
      this.createParamTags();
    },
    createParamTags() {
      let arr =
        this.items.map(item => {
          return {
            name: item.text
          };
        }) || [];
      if (!arr || (arr && !arr.length)) {
        this.$emit("submit", JSON.stringify(arr));
      } else {
        this.$emit("submit", "");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  display: flex;
  align-items: center;
  width: 528px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.items {
  display: flex;
  align-items: center;
}
.item {
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  background-color: #5778fb;
  margin-right: 8px;
  padding: 0 1em;
  color: #fff;
  transition-duration: 0.3s;
  & > .remove-btn {
    position: relative;
    display: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 1px solid #fff;
    margin-left: 1em;
    cursor: pointer;
    transform: rotate(45deg);
    &:before,
    &:after {
      content: " ";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 1px;
      width: 6px;
      background-color: #fff;
    }
    &:after {
      height: 6px;
      width: 1px;
    }
  }
  &:hover > .remove-btn {
    display: block;
  }
}
.title {
  position: absolute;
  top: 50%;
  right: calc(100% + 28px);
  transform: translateY(-50%);
  min-width: 100px;
  text-align: right;
  font-size: 14px;
  color: #474261;
}
.input {
  flex-grow: 1;
  height: 40px;
  background: #f8f8fc;
  border: 1px solid #ddd9eb;
  font-size: 14px;
  padding-left: 15px;
  padding-right: 15px;
  color: #333;
  &::placeholder {
    color: #c1c1d0;
  }
}
.tip {
  position: absolute;
  left: 1em;
  bottom: -8px;
  color: red;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitleExport/tagsField.vue